module.exports = __webpack_public_path__ + "img/step4.44dd242d.png";